import * as React from 'react';

import { Blocks } from 'react-loader-spinner';
//=========================================================================================//

export interface IMySpinnerProps {
    active: boolean;
    children: JSX.Element;
}




export const BlocksSpinner: React.FC<IMySpinnerProps> = (props: IMySpinnerProps) => {
    return (
        <div style={{ position: 'relative', display: 'block', width: '100%'}}>
            <div style={{ display: 'block' }}>{props.children}</div>
            {props.active && (
                <div
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',

                        backgroundColor: 'rgba(50, 50, 50, 0.5)',

                        zIndex: 9999,
                        pointerEvents: 'all',
                    }}
                >
                    <Blocks height={80} width={80} color="#4fa94d" />
                </div>
            )}
        </div>
    );
}
